import { Controller } from "stimulus"

// Preserve search terms across navigation
export default class extends Controller {
  static targets = ["input"]
  static values = { 
    page: String 
  }

  connect() {
    this.updateLinksOnPageLoad()
  }

  updateLinksOnPageLoad() {
    // Get search term from URL parameters or sessionStorage
    const searchTerm = this.getCurrentSearch()
    
    if (searchTerm) {
      // Update navigation links
      this.updateNavigationLinks(searchTerm)
      
      // Store in sessionStorage for persistence
      sessionStorage.setItem('currentSearchTerm', searchTerm)
    }
  }

  getCurrentSearch() {
    // Try URL parameters first
    const urlParams = new URLSearchParams(window.location.search)
    let searchTerm = urlParams.get('search') || urlParams.get('search_query') || urlParams.get('search_cut')
    
    // If not in URL, try sessionStorage
    if (!searchTerm) {
      searchTerm = sessionStorage.getItem('currentSearchTerm')
    }
    
    return searchTerm
  }

  updateNavigationLinks(searchTerm) {
    if (!searchTerm) return

    const navLinks = document.querySelectorAll('#nav-links a')
    navLinks.forEach(link => {
      const href = link.getAttribute('href')
      if (href && !href.includes('?')) {
        // Add appropriate search parameter based on the path
        if (href.includes('/portal')) {
          link.setAttribute('href', `${href}?search_query=${encodeURIComponent(searchTerm)}`)
        } else if (href.includes('/editions/')) {
          link.setAttribute('href', `${href}?search_cut=${encodeURIComponent(searchTerm)}`)
        } else if (href.includes('/events') || href.includes('/consultations') || href.includes('/podcasts')) {
          link.setAttribute('href', `${href}?search=${encodeURIComponent(searchTerm)}`)
        }
      }
    })
  }

  searchChanged() {
    const searchTerm = this.inputTarget.value
    if (searchTerm) {
      sessionStorage.setItem('currentSearchTerm', searchTerm)
      this.updateNavigationLinks(searchTerm)
    } else {
      sessionStorage.removeItem('currentSearchTerm')
    }
  }
}
